import React from 'react';
import { TICKET_STATUS } from '../../services/supportService';

const TicketStats = ({ counts, isLoading }) => {
  // Définition des cartes de statistiques avec leurs styles
  const getStatCards = () => [
    {
      title: "Nouveaux",
      value: counts[TICKET_STATUS.NEW] || 0,
      colorClass: "bg-info/10 border-info text-info",
      description: "Tickets en attente"
    },
    {
      title: "En cours",
      value: counts[TICKET_STATUS.IN_PROGRESS] || 0,
      colorClass: "bg-warning/10 border-warning text-warning",
      description: "Tickets en traitement"
    },
    {
      title: "Résolus",
      value: counts[TICKET_STATUS.RESOLVED] || 0,
      colorClass: "bg-success/10 border-success text-success",
      description: "Tickets résolus"
    },
    {
      title: "Fermés",
      value: counts[TICKET_STATUS.CLOSED] || 0,
      colorClass: "bg-neutral/10 border-neutral text-base-content/70",
      description: "Tickets archivés"
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
      {isLoading ? (
        // Affichage pendant le chargement
        Array(4).fill(0).map((_, index) => (
          <div key={index} className="bg-base-100 rounded-lg shadow-sm p-4 animate-pulse">
            <div className="h-4 bg-base-300 rounded w-1/3 mb-2"></div>
            <div className="h-8 bg-base-300 rounded w-1/4 mb-2"></div>
            <div className="h-3 bg-base-300 rounded w-1/2"></div>
          </div>
        ))
      ) : (
        // Affichage des statistiques
        getStatCards().map((card) => (
          <div
            key={card.title}
            className={`border-l-4 rounded-lg shadow-sm p-4 ${card.colorClass}`}
          >
            <h3 className="font-bold mb-1">{card.title}</h3>
            <p className="text-3xl font-bold text-base-content">{card.value}</p>
            <p className="text-sm text-base-content/70 mt-1">{card.description}</p>
          </div>
        ))
      )}
    </div>
  );
};

export default TicketStats;